export default "__VITE_ASSET__Bgj7c4jg__"